import React, { useState, useEffect, RefObject } from 'react';
import clsx from 'clsx';

import { ReactComponent as ArrowDownIcon } from 'images/arrow-down.svg';

import styles from './ScrollToBottomButton.module.scss';

interface ScrollToBottomButtonProps {
  scrollRef: RefObject<HTMLDivElement>;
  scrollThreshold?: number;
  blockButton?: boolean;
}

const ScrollToBottomButton = ({ scrollRef, scrollThreshold = 200, blockButton }: ScrollToBottomButtonProps) => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current && !blockButton) {
        const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
        const distanceFromBottom = scrollHeight - scrollTop - clientHeight;

        setShowButton(distanceFromBottom > scrollThreshold);
      }
    };

    const scrollElement = scrollRef.current;
    if (scrollElement) {
      scrollElement.addEventListener('scroll', handleScroll);
      return () => scrollElement.removeEventListener('scroll', handleScroll);
    }
  }, [scrollRef, scrollThreshold, blockButton]);

  const scrollToBottom = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: scrollRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  };

  return (
    <button
      type="button"
      className={clsx(styles.scrollToBottomButton, { [styles.show]: showButton })}
      onClick={scrollToBottom}
    >
      <ArrowDownIcon />
    </button>
  );
};

export default ScrollToBottomButton;
